import { render, staticRenderFns } from "./ConfirmForm.vue?vue&type=template&id=641f9e91&scoped=true"
import script from "./ConfirmForm.vue?vue&type=script&lang=js"
export * from "./ConfirmForm.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForm.vue?vue&type=style&index=0&id=641f9e91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f9e91",
  null
  
)

export default component.exports